import { render, staticRenderFns } from "./coperentegre.vue?vue&type=template&id=6d3af876&scoped=true&"
import script from "./coperentegre.vue?vue&type=script&lang=js&"
export * from "./coperentegre.vue?vue&type=script&lang=js&"
import style0 from "./coperentegre.vue?vue&type=style&index=0&id=6d3af876&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3af876",
  null
  
)

export default component.exports